export function random() {
    return Math.floor(Math.random() * Math.floor(99999))
}